module.exports = __webpack_public_path__ + "static/media/doremi_00001_journey_forest_after.79d9118a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/doremi_00001_journey_forest_after.png
// module id = 219
// module chunks = 0